import { render, staticRenderFns } from "./DxInformationPrescription.vue?vue&type=template&id=4b8f3897&"
import script from "./DxInformationPrescription.vue?vue&type=script&lang=js&"
export * from "./DxInformationPrescription.vue?vue&type=script&lang=js&"
import style0 from "./DxInformationPrescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports